import { KTIcon } from "../../../../../_metronic/helpers";

const ListingEditModalHeader = ({
  setSelectedListingId,
  setOpenEditListing,
  listing
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <h2 className="fw-bolder listing_title">Edit Details of {listing.title}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setSelectedListingId()
          setOpenEditListing(false)
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { ListingEditModalHeader };
